var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51158 3.44469L10.9171 1.03848C11.1879 0.772073 11.553 0.623458 11.9329 0.625012C12.3128 0.626566 12.6766 0.778161 12.9452 1.04678C13.2139 1.3154 13.3655 1.67927 13.367 2.05915C13.3686 2.43903 13.22 2.80414 12.9535 3.07494L10.5473 5.48044L11.8493 11.9581C12.0157 12.7869 10.4085 13.9415 9.98067 12.8436L8.07525 7.95323L5.60104 10.4274C5.72146 11.8732 5.74767 12.3541 4.73404 13.367L3.19342 10.7986L0.625 9.25798C1.63792 8.24436 2.11888 8.26986 3.56458 8.39098L6.03879 5.91748L1.14846 4.01136C0.0505418 3.58353 1.20512 1.97561 2.03387 2.14278L8.51158 3.44469Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.f0833a8234339269724c9a61dcfe6fb7.svg";
export { ForwardRef as ReactComponent };